var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#797979;}.cls-1,.cls-2{stroke:#797979;stroke-miterlimit:10;stroke-width:3px;}.cls-3{fill:#fff;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.5,
    y: 1.5,
    width: 160,
    height: 90,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.5,
    y: 1.5,
    width: 160,
    height: 90,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.12 46.05 33.12 46.05 8.12 89.35 8.12 89.35 36.49 89.35 55.94 89.35 33.12 46.05"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60.04,
    cy: 22.7,
    r: 6.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 116.09,
    y: 68.96,
    width: 21.89,
    height: 20.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.03 48.4 114.5 66.79 139.56 66.79 127.03 48.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 130.41,
    y: 70.44,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 117.66,
    y: 70.44,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.03,
    y: 80.97,
    width: 6,
    height: 9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photo_placeholder.f012397afa843ecf4dff32dc73f930c2.svg";
export { ForwardRef as ReactComponent };